module.exports = __webpack_public_path__ + "img/1.9ad558e2.jpg";